import Module from '../Module';

export default class Summary extends Module {
    constructor(title, index, dataProcessingConsentText, dataProtectionUrl) {
        // Chain constructor with super
        super(title, index, 'summary');
        this._title = title || 'Zusammenfassung & Senden';
        this._renderThankYou = false;
        this._dataProcessingConsentText = dataProcessingConsentText || "Ich erkläre meine Einwilligung zur Erhebung, Verarbeitung und Nutzung\n" +
            "meiner personenbezogenen Daten nur zum Zweck der Kontaktaufnahme und Angebotserstellung\n" +
            "gemäß der Datenschutzerklärung.";
        this._dataProtectionUrl = dataProtectionUrl || '/datenschutz/';
        this._dataProcessingConsent = false;
    }

    get dataProcessingConsentText() {
        return this._dataProcessingConsentText;
    }

    get dataProcessingConsentHtml() {
        let html = this.dataProcessingConsentText.replace(/(Datenschutzerklärung)/, `<a href="${this._dataProtectionUrl}" target="_blank">$1</a>`);
        if (html === this.dataProcessingConsentText) {
            html += '<br><a href="' + this._dataProtectionUrl + '" target="_blank">Datenschutzerklärung öffnen</a>'
        }
        return html;
    }

    get dataProcessingConsent() {
        return this._dataProcessingConsent;
    }

    set dataProcessingConsent(value) {
        this._dataProcessingConsent = value;
    }

    get renderThankYou() {
        return this._renderThankYou;
    }

    set renderThankYou(renderThankYou) {
        this._renderThankYou = renderThankYou;
    }

    fillDummyData() {
        this._dataProcessingConsent = true;
    }

    removeDummyData() {
        this._dataProcessingConsent = false;
    }
}